/* eslint-disable @typescript-eslint/prefer-destructuring */
/* eslint-disable prefer-destructuring */
import { posthog } from 'posthog-js'

import type { PostHog } from 'posthog-js'

let posthogClient: PostHog | null = null

export function getPosthogClient(): PostHog | null {
  return posthogClient
}

function trackClick(event: Event) {
  if ('composed' in event && typeof event.composedPath === 'function') {
    // Get the path of elements the event climbed through, e.g.
    // [span, div, div, section, body]
    // oxlint-disable-next-line no-explicit-any
    const path = event.composedPath() as any[]

    // Fetch reference to the element that was actually clicked
    const targetElement = path[0]!

    const gtmIds = path
      .map(e => e?.attributes?.['data-gtm-id']?.value)
      .filter(id => !!id)

    if (targetElement !== null && gtmIds.length > 0) {
      // Push to dataLayer
      // oxlint-disable-next-line no-explicit-any
      const trackingEvent = {
        clickText: targetElement.innerText || '',
        config: window?.RevolugoElements?.config || {},
        element: targetElement,
        elementClasses: targetElement.className || '',
        elementId: targetElement.id || '',
        elementTarget: targetElement.target || '',
        elementType: targetElement.type || '',
        elementUrl: targetElement.href || targetElement.action || '',
        elementValue: targetElement.value || '',
        event: 'custom.click',
        gtmId: gtmIds[0],
        originalEvent: event,
      }

      // oxlint-disable-next-line no-explicit-any
      const dataLayer = (window as unknown as any).dataLayer

      if (dataLayer) {
        dataLayer.push(trackingEvent)
      }
    }
  }
}

/* eslint-disable camelcase */
export default defineNuxtPlugin(() => {
  const runtimeConfig = useRuntimeConfig()

  // Only initialize PostHog if POSTHOG_KEY is provided
  if (runtimeConfig.public.POSTHOG_KEY) {
    posthogClient = posthog.init(runtimeConfig.public.POSTHOG_KEY, {
      api_host: runtimeConfig.public.POSTHOG_HOST,
      capture_pageview: false,
      // eslint-disable-next-line @typescript-eslint/no-shadow
      loaded: posthog => {
        if (import.meta.env.MODE === 'development') {
          posthog.debug()
        }
      },
      person_profiles: 'identified_only',
    })

    const router = useRouter()
    router.afterEach(async (to: { fullPath: string }) => {
      await nextTick(() => {
        posthog.capture('$pageview', {
          current_url: to.fullPath,
        })
      })
    })
  }

  useHead({
    script: [
      {
        async: true,
        id: 'gtm-script',
        onload:
          "window.dataLayer = window.dataLayer || [];function gtag(){window.dataLayer.push(arguments);};gtag('consent', 'default', {'ad_storage': 'granted','ad_user_data': 'granted','ad_personalization': 'granted','analytics_storage': 'granted'});window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });",
        src: `https://www.googletagmanager.com/gtm.js?id=${runtimeConfig.public.GTM_ID}`,
      },
    ],
  })

  try {
    document.addEventListener('click', trackClick)
  } catch (error) {
    // oxlint-disable-next-line no-console
    console.error(error)
  }

  return {
    provide: {
      posthog: () => posthogClient,
    },
  }
})
/* eslint-enable camelcase */
